































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray
} from '../../core/utils';
import ListWithItems from '../../core/components/ListWithItems.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Combobox from '../../core/components/Combobox.vue';
import { MsgBox, PlusEyeButtons, Breadcrums, CloseConfirmationModal } from '../../core/components';
import { AuthStoreHelper, RootStoreHelper, CompanyStoreHelper, NotificationStoreHelper } from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';

@Component({
    components: {
        multiselect,
        Loading,
        Combobox,
        PlusEyeButtons,
        Breadcrums,
        ListWithItems,
        CloseConfirmationModal
    }
})
export default class DownloadingModal extends Mixins(
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: false }) hiddenDownload: boolean;
    @Prop({ default: 'Descargar archivo' }) modalTitle: string;
    visible: boolean = false;
    secondPlaceDownload: boolean = false;
    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;

    updateVisible(value) {
        this.visible = value;
    }

    continueInSecondPlace() {
        setTimeout(() => {
            this.$_showLoadingDialog('');
        }, 1000);
    }

    showLoadingDialog(msg){
         if (!this.secondPlaceDownload) {
            this.updateVisible(true);
            this.$_showLoadingDialog(msg);
         }
        
    }
    showSuccessLoadingDialog(response, alternative_msg){
        if (!this.secondPlaceDownload) {
            this.$_successLoadingDialog({
                response: response,
                alternative_msg: alternative_msg
            });
        }else{
            this.$_showAddPointOfInterest(alternative_msg);
            this.secondPlaceDownload = false;
        }
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }
}
